var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-select-main" }, [
    _c("div", { staticClass: "customer-select-title text-center" }, [
      _vm._v(
        "Please select the specific business you are purchasing for to better customize your ordering experience"
      ),
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "company-select-hr" }),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid p-0 px-sm-3" }, [
      _c("div", { staticClass: "row mx-sm-n3 mb-4" }, [
        _c("div", { staticClass: "col-sm-4 px-sm-3" }, [
          _c(
            "div",
            {
              staticClass: "company-card",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  return _vm.setCompany("KOCBUS")
                },
              },
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", {
                  attrs: { src: _vm.kochImageUrl, alt: "Koch Logo" },
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center link",
                },
                [
                  _c("div", [_vm._v("Koch Bundles and Devices")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.arrow } }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 px-sm-3" }, [
          _c(
            "div",
            {
              staticClass: "company-card",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  return _vm.setCompany("KOCHGP")
                },
              },
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", {
                  attrs: { src: _vm.gpImageUrl, alt: "Georgia Pacific Logo" },
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center link",
                },
                [
                  _c("div", [_vm._v("GP Bundles and Devices")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.arrow } }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 px-sm-3" }, [
          _c(
            "div",
            {
              staticClass: "company-card",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  return _vm.setCompany("KOCMOL")
                },
              },
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", {
                  attrs: { src: _vm.molexImageUrl, alt: "Molex Logo" },
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center link",
                },
                [
                  _c("div", [_vm._v("Molex Bundles and Devices")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.arrow } }),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mx-sm-n3" }, [
        _c("div", { staticClass: "col-sm-4 px-sm-3" }, [
          _c(
            "div",
            {
              staticClass: "company-card",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  return _vm.setCompany("KOCGUA")
                },
              },
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", {
                  attrs: { src: _vm.guardianImageUrl, alt: "Guardian Logo" },
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center link",
                },
                [
                  _c("div", [_vm._v("Guardian Bundles and Devices")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.arrow } }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 px-sm-3" }, [
          _c(
            "div",
            {
              staticClass: "company-card",
              attrs: { role: "button" },
              on: {
                click: function ($event) {
                  return _vm.setCompany("KOCINV")
                },
              },
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", {
                  attrs: { src: _vm.invistaImageUrl, alt: "Invista Logo" },
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center link",
                },
                [
                  _c("div", [_vm._v("Invista Bundles and Devices")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.arrow } }),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }